import { writable } from 'svelte/store';

export function createTranslationsStore(usedAttributesConfigStore, usedAvailableRatingsStore, usedSelectedRatingsStore) {
    const { subscribe, set, update } = writable({});

    const translate = (key) => {
        if (typeof key !== 'string') {
            key = '' + key;
        }

        // remove placeholder interpolation from legacy Portal app
        key = key.replace('{{', '').replace('}}', '');

        let value;
        subscribe((state) => {
            value = state[key] ?? key;
        })();
        return value;
    };

    const translateReplaceValues = (key, attribute = null) => {
        let availableAttributes;
        usedAttributesConfigStore.subscribe((state) => {
            availableAttributes = state;
        });

        let availableRatings;
        usedAvailableRatingsStore.subscribe((state) => {
            availableRatings = state;
        });

        let selectedRatings;
        usedSelectedRatingsStore.subscribe((state) => {
            selectedRatings = state;
        });

        let ratingName = translate('filter_multiple_companies');
        if (selectedRatings?.length === 1) {
            ratingName = availableRatings.find((rating) => rating.id === selectedRatings[0])?.name;
        }

        const ratingsRegex = /(%2\$s|%s)/g;

        let result = translate(key).replace(ratingsRegex, ratingName);

        if (attribute) {
            result = result.replace('%1$s', translate(availableAttributes[attribute].name));
        }

        return result;
    };

    const translateAndReplace = (key, placeholderToValue) => {
        let result = translate(key);
        for (const [placeholder, value] of Object.entries(placeholderToValue)) {
            result = result.replace(`:${placeholder}`, value);
        }

        return result;
    };

    return {
        subscribe,
        set,
        update,
        translate,
        translateReplaceValues,
        translateAndReplace,
    };
}
